import { Classification } from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';
import { HandleClassificationsChangeParams, ResetFieldsParams } from '../types';

export function handleClassificationsChange({ form }: HandleClassificationsChangeParams) {
  return (options: Classification[]): void => {
    form.setFieldValue('classifications', options);
  };
}

export function resetFields({
  form,
  record,
  setSelectedParents,
  setSelectedChildren,
}: ResetFieldsParams): void {
  if (!record) {
    return;
  }

  const initialParents = record.parents || [];
  const initialChildren = record.children || [];

  form.reset();
  form.setValues({
    name: record.name || '',
    imageUrl: record.imageUrl || '',
    description: record.description || '',
    mainItems: [],
    taxRate: record.taxRate || '',
    externalId: record.externalId || '',
    internalName: record.internalName || '',
    itemId: record.uuid || '',
    minimum: record.minimum ?? 0,
    maximum: record.maximum ?? 0,
    multipleModifiersEnabled: !!record.individualMaximum,
    individualMinimum: record.individualMinimum ?? null,
    individualMaximum: record.individualMaximum ?? null,
    price: record.price ?? '',
    secondaryPrice: record.secondaryPrice ?? '',
    classifications: record.classifications || [],
    isDefault: record.isDefault ? 'true' : 'false',
    posId: record.externalId || '',
    uploadImageFile: null,
  });

  setSelectedParents(initialParents);
  setSelectedChildren(initialChildren);
}
